var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7609 4.42881C23.7609 4.42881 23.5266 2.77412 22.8047 2.04756C21.8906 1.09131 20.8688 1.08662 20.4 1.03037C17.0438 0.786621 12.0047 0.786621 12.0047 0.786621H11.9953C11.9953 0.786621 6.95625 0.786621 3.6 1.03037C3.13125 1.08662 2.10938 1.09131 1.19531 2.04756C0.473438 2.77412 0.24375 4.42881 0.24375 4.42881C0.24375 4.42881 0 6.37412 0 8.31475V10.1335C0 12.0741 0.239062 14.0194 0.239062 14.0194C0.239062 14.0194 0.473437 15.6741 1.19062 16.4007C2.10469 17.3569 3.30469 17.3241 3.83906 17.4272C5.76094 17.6101 12 17.6663 12 17.6663C12 17.6663 17.0438 17.6569 20.4 17.4179C20.8688 17.3616 21.8906 17.3569 22.8047 16.4007C23.5266 15.6741 23.7609 14.0194 23.7609 14.0194C23.7609 14.0194 24 12.0788 24 10.1335V8.31475C24 6.37412 23.7609 4.42881 23.7609 4.42881ZM9.52031 12.3413V5.596L16.0031 8.98037L9.52031 12.3413Z",
    fill: "#313E4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.5a584d6f449f8f469efc10273cec61e5.svg";
export { ForwardRef as ReactComponent };